import {call} from "redux-saga/effects";
import * as HttpService from 'services/HttpService';
import {takeLatest, put} from 'redux-saga/effects';
import {
    loadPublicTnC,
    publicTncLoaded,
    failedToLoadResource,
    publicPpLoaded,
    loadPublicPp,
    updateTnc,
    tncUpdated,
    updatePp,
    ppUpdated,
} from "../slices/resourcesSlice";
import {notification} from "antd";

const endpoint = '/resources';

function* fetchTnc() {
    try {
        const response = yield call(HttpService.get, `${endpoint}/tnc`);
        const {tnc} = response.data;
        if (tnc) {
            yield put(publicTncLoaded(tnc));
        }
    } catch (error) {
        yield put(failedToLoadResource());
    }
}

function* fetchPp() {
    try {
        const response = yield call(HttpService.get, `${endpoint}/pp`);
        const {pp} = response.data;
        if (pp) {
            yield put(publicPpLoaded(pp));
        }
    } catch (error) {
        yield put(failedToLoadResource());
    }
}

function* updateTncRequest(action) {
    const {tnc} = action.payload;
    try {
        const response = yield call(HttpService.post, `/admin${endpoint}/tnc`, {tnc});
        if (response) {
            notification.success({message: 'Success', description: 'Terms and Conditions updated successfully'});
            yield put(tncUpdated());
        }
    } catch (error) {
        yield put(failedToLoadResource());
    }
}

function* updatePpRequest(action) {
    const {pp} = action.payload;
    try {
        const response = yield call(HttpService.post, `/admin${endpoint}/pp`, {pp});
        if (response) {
            notification.success({message: 'Success', description: 'Privacy Policy updated successfully'});
            yield put(ppUpdated());
        }
    } catch (error) {
        yield put(failedToLoadResource());
    }
}

export default function* resourcesSaga() {
    yield takeLatest(loadPublicTnC.type, fetchTnc);
    yield takeLatest(loadPublicPp.type, fetchPp);
    yield takeLatest(updateTnc.type, updateTncRequest);
    yield takeLatest(updatePp.type, updatePpRequest);
}
